
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gkEwyr3Su_459EL6eyK8O9dryiPwPe6Zgi8ksopJi1_45xBMMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexEhLZQkTh81SvhpIgxTnnUNKJjroLBWI_NCvIhcaHSmwMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchOvtkqst7YFVImJLwTTnSiWIRTqhO1qe8_oJHoBMpuUcMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index4_45ARsKCY8CPd385To2vaSuYs0XSMEtuuTrjE4PTypdgMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Wb0bFNNQMSCrybXH1oyTi8B3w7QrS_5N5on5RqWDXHoMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index02t4lgc91victJwtoCm733rIqu0RFWLg8KJmb2FRM1QMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_45JEr5eOu2Jww4MwmqN_vM54qzFkZeSuD7_iGxYL_45SxsMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index_kRP94JmggmoNhU1emzyl63cBCtzawv8_45Ef6pC7oQCgMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93DHV15c2v28IPM6NTCvVP2WvH347A7lTLRu56lO_jtOsMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexhjrY_45Q8pO6Y0f4QJ5QWVimCzsVXSlfIz7vGr_jHsmSsMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexKNsfzEKFjamVpVQyFPZXJu52zlwn5__45uirqcLn_45_45GucMeta } from "/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index02t4lgc91victJwtoCm733rIqu0RFWLg8KJmb2FRM1QMeta || {},
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index_kRP94JmggmoNhU1emzyl63cBCtzawv8_45Ef6pC7oQCgMeta || {},
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexhjrY_45Q8pO6Y0f4QJ5QWVimCzsVXSlfIz7vGr_jHsmSsMeta || {},
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexKNsfzEKFjamVpVQyFPZXJu52zlwn5__45uirqcLn_45_45GucMeta || {},
    component: () => import("/codebuild/output/src1918583420/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]